var Formation_citation = {
    init:function(){
        var swiper = new Swiper(".block-video-and-citation .swiper-container-citation", {
            slidesPerView:'auto',
            spaceBetween: 20,
            breakpoints: {
                
                1040: {
                    spaceBetween: 35,
                }
              }
          });
    }
}

$(window).load(function(){
    if($('.block-video-and-citation').length){
        Formation_citation.init();
    }
})